import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Grid,
  Text
} from './../../../components'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  TitleSectionWrapper
} from './styled'

export class TitleSection extends React.PureComponent {
  render() {
    const {
      className,
      name,
      message,
      children,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'title-section',
      className
    )

    return (
      <TitleSectionWrapper
        className={classes}
      >
        <Grid>
          <Grid.Column flex='1'>
            <Text
              regular16
              color={VARIABLES.COLORS.PRIMARY_2}
            >
              {name}
            </Text>
            {message &&
              <Text
                regular16
                color={VARIABLES.COLORS.RED_4}
              >
                &nbsp;{message}
              </Text>
            }
          </Grid.Column>

          {children &&
            <Grid.Column flex='none'>
              {children}
            </Grid.Column>
          }
        </Grid>
      </TitleSectionWrapper>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
